// @system — Default landing page content. Override in @custom/landing.js.
// Product-neutral on purpose: a generated site never shows the template's own pitch.
export default {
  heroTitle: 'Build your product faster',
  heroSubtitle: 'Create your account, invite your team and get started in minutes.',
  ctaButton: 'Get Started',
  ctaSecondary: 'View Pricing',
  featuresTitle: 'What you get',
  featuresSubtitle: 'The core of the product, ready from the first sign-in.',
  pricingTitle: 'Simple pricing',
  pricingSubtitle: 'One plan, everything included. No hidden fees.',
  faqTitle: 'Frequently asked questions',
}
